// src/components/front/SubscribeCta.js
import React from "react";
import PropTypes from "prop-types";
import { SubscribeFormNew } from "../global/SubscribeFormNew";

const SubscribeCta = (props) => {
  const data = props.data || {};

  // ✅ Defaults that always render, overridden by WP when present
  const number   = data.number   ?? "07";
  const subtitle = data.subtitle ?? "Subscribe";
  const title    = data.title    ?? "Newsletter";
  const copy     = (data.text ?? data.copy) ?? "Sign up to get monthly updates";
  const bgClass  = data.bgClass ?? data.bgclass ?? "bg-pink";

  return (
    <div className="pt-lg-11 pb-lg-21 pb-16 pt-11" id="subscribe">
      <div className="container">
        <div className="border border-1 rounded-40 subscribe-widget">
          <div className="row align-items-xl-start align-items-md-start">
            <div className="col-12 mb-6 mb-lg-0 col-lg-6">
              <div className="d-flex flex-column gap-4">
                <div>
                  <span className={`zg-label ${bgClass} text-black me-2 d-inline-block`}>
                    {number}
                  </span>
                  <span className={`zg-label ${bgClass} text-black d-inline-block`}>
                    {subtitle} 
                  </span>
                </div>

                <h2 className="h3 m-0 letter-spacing-4">{title}</h2>
                <p className="fs-7 m-0">{copy}</p>
              </div>
            </div>

            <div className="col-12 col-lg-6 col-xl-5 offset-xl-1 new-form">
              <SubscribeFormNew />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

SubscribeCta.propTypes = {
  data: PropTypes.shape({
    number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    subtitle: PropTypes.string,
    title: PropTypes.string,
    text: PropTypes.string,
    bgClass: PropTypes.string,
    bgclass: PropTypes.string,
  }),
};

export default SubscribeCta;
